import React, {useContext} from 'react'
import {AuditContext} from '../../context/Audits'
import {TemplatesContext} from '../../context/Templates'
import {AuditPaneContext} from '../../context/AuditPane'
import {useTranslation} from 'react-i18next'
import {Dropdown} from 'react-bootstrap'
import {AuditDetailsContext} from '../../context/Modal/AuditDetails'
import {GroupDetailsContext} from '../../context/Modal/GroupDetails'
import {AssignAuditContext} from '../../context/Modal/AssignAudit'
import {EditAuditContext} from '../../context/Modal/EditAudits'
import {AuditModalBarContext} from '../../context/AuditModalBar'
import {RecurringDetailsContext} from '../../context/Modal/RecurringDetails'
import {UserContext} from '../../context/User'
import {ToastMessageContext} from '../../context/ToastMessage'
import moment from 'moment'
import {useModal} from '../../common/Modal'

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <button
    className="audit-dropdown__toggle audit-dropdown__toggle--icon"
    ref={ref}
    onClick={e => {
      e.stopPropagation()
      onClick(e)
    }}
  >
    {children}
  </button>
))

function AuditAdminMenu({data, expand}) {
  const {selectAudit, remove, editAudit, closeAuditIndividual, audit, audits} = useContext(
    AuditContext
  )
  const {
    selectTemplate,
    templateAudits,
    getAudits,
    template,
    templates,
    removeTemplate,
    updatedTemplateAuditList,
  } = useContext(TemplatesContext)
  const paneState = useContext(AuditPaneContext)
  const barState = useContext(AuditModalBarContext)
  const {t} = useTranslation()
  const {
    setAuditId,
    setName,
    setMethod,
    setStartDate,
    setDueDate,
    setAllowScanningAfterDurDate,
    setDueSoonDays,
    setGpsDetails,
    setAssetDetails,
    setAuditStatus,
    setInBufferTime,
  } = useContext(AuditDetailsContext)
  const {
    setGroupDetails,
    setAllowAutoUpdateField,
    setAllowUserUpdateField,
    setAllowUserWithoutEditPermission,
  } = useContext(GroupDetailsContext)
  const {
    setIndividualAudit,
    setAuditUsersAttributes,
    setAuditEmailUsersAttributes,
    setAuditUserTemplatesAttributes,
  } = useContext(AssignAuditContext)
  const {random} = useContext(EditAuditContext)
  const {setRecurrenceAttributes, setRecurrence} = useContext(RecurringDetailsContext)
  const currentUser = useContext(UserContext)
  const toast = useContext(ToastMessageContext)
  const simpleModal = useModal('simple', {})

  const isTemplate = (paneState.activeTab === 'audit' || expand ? false : true) || false
  const auditPermission =
    data.audit_type_for_user === 'created' || currentUser.details.is_admin ? true : false

  const getCloseAuditPermission = () => {
    let permission = false
    if (!isTemplate) {
      if (data.status === 'open') {
        if (auditPermission) {
          permission = true
        }
      }
    }
    return permission
  }

  const getReopenAuditPermission = () => {
    let today = new Date(moment(new Date()).format('MM/DD/YYYY'))
    let permission = false
    if (!isTemplate) {
      if (data.status === 'completed' && auditPermission) {
        if (new Date(data.due_date) >= today) {
          permission = true
        } else if (data.allow_scanning_after_due_date) {
          permission = true
        }
      }
    }
    return permission
  }
  const closeAuditPermission = getCloseAuditPermission()

  const auditdata = (data, type) => {
    setAuditId(data.id)
    setAuditStatus(data.status)
    setMethod(data.method)
    setAllowScanningAfterDurDate(data.allow_scanning_after_due_date)
    setDueSoonDays(data.due_date && data.due_date !== '12/31/2100' ? data.due_soon_days : 3)
    setGpsDetails(data.gps_location)
    setAssetDetails(data.asset_details)
    if (data.audit_entities_attributes[0].audit_entity_auto_update_fields_attributes.length > 0) {
      setAllowAutoUpdateField(true)
    }
    if (data.audit_entities_attributes[0].audit_entity_user_fields_attributes.length > 0) {
      setAllowUserUpdateField(true)
    }
    setAllowUserWithoutEditPermission(data.allow_user_without_edit_permission)
    setIndividualAudit(data.individual_audit)
    data.recurrence_attributes && setRecurrence(data.recurrence_attributes.status)
    data.recurrence_attributes &&
      setRecurrenceAttributes({
        id: data.recurrence_attributes.id,
        status: data.recurrence_attributes.status,
        frequency: data.recurrence_attributes.frequency,
        duration: data.recurrence_attributes.duration,
        willStop:
          data.recurrence_attributes.occurrences !== 0 &&
          data.recurrence_attributes.occurrences !== 999
            ? 'After'
            : 'Never',
        occurrences:
          data.recurrence_attributes.occurrences !== 0 &&
          data.recurrence_attributes.occurrences !== 999
            ? data.recurrence_attributes.occurrences
            : 1,
        audit_appear_days: data.recurrence_attributes.audit_appear_days,
      })
    setGroupDetails(
      data.audit_entities_attributes.map(attr => {
        return {
          entity_id: attr.entity_id,
          entity_name: attr.entity_name,
          audit_entity_field_attributes: {
            field_id: attr.audit_entity_field_attributes.field_id,
            field_name: attr.audit_entity_field_attributes.field_name,
          },
          audit_entity_filters_attributes: attr.audit_entity_filters_attributes.map(filter => {
            return {
              field_id: filter.field_id,
              field_type: filter.field_type,
              field_name: filter.field_name,
              value_id: filter.value_id,
              value_name: filter.value_name,
              values: filter.values,
            }
          }),
          audit_entity_auto_update_fields_attributes: attr.audit_entity_auto_update_fields_attributes.map(
            field => {
              return {
                field_id: field.field_id,
                field_type: field.field_type,
                field_name: field.field_name,
                value_id: field.value_id,
                value_name: field.value_name,
              }
            }
          ),
          audit_entity_user_fields_attributes: attr.audit_entity_user_fields_attributes.map(
            user => {
              return {
                field_id: user.field_id,
                field_name: user.field_name,
              }
            }
          ),
        }
      })
    )
    setAuditUsersAttributes(
      data.audit_users_attributes.map(attr => {
        return {
          user_id: attr.user_id,
          user_name: attr.user_name,
          account_id: attr.account_id,
        }
      })
    )
    setAuditEmailUsersAttributes(
      data.audit_email_users_attributes.map(attr => {
        return {
          user_id: attr.user_id,
          user_name: attr.user_name,
        }
      })
    )
    setAuditUserTemplatesAttributes(
      data.audit_user_templates_attributes.map(attr => {
        return {
          template_id: attr.template_rule_id,
          template_name: attr.template_name,
          template_rule_id: attr.template_rule_id,
        }
      })
    )
    if (type === 'edit') {
      setAuditUsersAttributes(
        data.audit_users_attributes.map(attr => {
          return {
            user_id: attr.user_id,
            user_name: attr.user_name,
          }
        })
      )
      setAuditUserTemplatesAttributes(
        data.audit_user_templates_attributes.map(attr => {
          return {
            id: attr.id,
            template_id: attr.template_rule_id,
            template_name: attr.template_name,
            template_rule_id: attr.template_rule_id,
          }
        })
      )
      setName(data.name)
      setStartDate(data.start_date)
      setInBufferTime(data.in_buffer_time)
      if (data.due_date && data.due_date !== '12/31/2100') setDueDate(data.due_date)
    } else if (type === 'duplicate' || type === 'schedule') {
      const min = 1
      const max = 10
      const rand = min + Math.random() * (max - min)
      const number = random + Math.trunc(rand)
      barState.setActiveForm()
      setName(data.name + `-${number}`)
      setStartDate(new Date())
      setDueDate('')
    }
  }

  const openEditAudit = data => {
    auditdata(data, 'edit')
    if (isTemplate) {
      paneState.editDetail('Template')
    } else {
      paneState.editDetail('Audit')
    }
  }

  const openDuplicateAudit = data => {
    auditdata(data, 'duplicate')
    if (isTemplate) {
      paneState.duplicateDetail('Template')
    } else {
      paneState.duplicateDetail('Audit')
    }
  }

  const openScheduleAudit = data => {
    auditdata(data, 'schedule')
    paneState.scheduleDetail()
  }

  const openExpandAudit = data => {
    if (audit === null || (audit && audit.selected && audit.selected.id !== data.id)) {
      selectAudit(data)
    }
    paneState.openAuditExpand('audit')
  }

  const openExpand = data => {
    if (isTemplate) {
      if (
        template === null ||
        (template && template.selected && template.selected.id !== data.id)
      ) {
        selectTemplate(data)
      }
    } else {
      if (
        audit === '' ||
        audit === null ||
        (audit && audit.selected && audit.selected.id !== data.id)
      ) {
        selectAudit(data)
      }
    }
    paneState.openExpand()
  }

  const tosterAlertPopup = response => {
    if (response !== null && response.status !== 500) {
      if (
        response.data.errors &&
        response.data.errors[0].base &&
        response.data.errors[0].base[0] !== undefined
      ) {
        toast.popMessage(response.data.errors[0].base[0], 'error')
      } else {
        toast.popMessage('Internal Server Error', 'error')
      }
    } else {
      toast.popMessage('Internal Server Error', 'error')
    }
  }

  const deleteAudit = (id, close) => {
    try {
      let index = audits.audits.findIndex(a => {
        return a.id === id
      })
      let auditName = audits.audits[index].name
      remove(id).then(response => {
        if (response.message !== undefined) {
          toast.popMessage(`${auditName} is deleted successfully`, 'success')
          if (expand) {
            getAudits({template_id: template.selected.id, column_name: 'name', sort_by: 'asc'})
          }
          if (audits.audits.length !== 0 && (paneState.isExpandOpen || paneState.isSidebarOpen)) {
            index = index === audits.audits.length ? index - 1 : index
            selectAudit(audits.audits[index])
          } else {
            paneState.resetDefault()
          }
          close()
        } else {
          tosterAlertPopup(response)
        }
      })
    } catch (e) {
      console.log(`Removed Successfully`)
    }
  }

  const deleteTemplate = (id, close) => {
    try {
      let index = templates.audits.findIndex(t => {
        return t.id === id
      })
      let templateName = templates.audits[index].name
      removeTemplate(id).then(response => {
        if (response.message !== undefined) {
          toast.popMessage(`${templateName} is deleted successfully`, 'success')
          if (
            templates.audits.length !== 0 &&
            (paneState.isExpandOpen || paneState.isSidebarOpen)
          ) {
            index = index === templates.audits.length ? index - 1 : index
            selectTemplate(templates.audits[index])
          } else {
            paneState.resetDefault()
          }
          close()
        } else {
          tosterAlertPopup(response)
        }
      })
    } catch (e) {
      console.log(`Removed Successfully`)
    }
  }

  const closeAuditCall = (data, close) => {
    var index = data.audit_users_attributes
      .map(function(e) {
        return e.user_id
      })
      .indexOf(data.user_id)

    try {
      close()
      editAudit(data.id, {status: 'completed'}).then(response => {
        if (response.id !== undefined) {
          toast.popMessage(`${data.name} is closed successfully`, 'success')
          if (expand) {
            updatedTemplateAuditList(getUpdatedArr(templateAudits.audits, response))
          } else {
            selectAudit(response)
          }
          //close()
        } else {
          tosterAlertPopup(response)
        }
      })
    } catch (e) {
      console.log(`Closed Successfully`)
    }
  }

  const getUpdatedArr = (audits, response) => {
    let newArr = audits
    var index = audits
      .map(function(e) {
        return e.id
      })
      .indexOf(response.id)
    newArr[index] = response
    return newArr
  }

  const reopenAudit = (id, close) => {
    let index = audits.audits.findIndex(a => {
      return a.id === id
    })
    let auditName = audits?.audits[index]?.name
    try {
      close()
      editAudit(id, {status: 'open'}).then(response => {
        if (response.id !== undefined) {
          toast.popMessage(`${auditName} is reopened successfully`, 'success')
          if (expand) {
            updatedTemplateAuditList(getUpdatedArr(templateAudits.audits, response))
          } else {
            selectAudit(response)
          }
          //close()
        } else {
          tosterAlertPopup(response)
        }
      })
    } catch (e) {
      console.log(`Repoen Failed`)
    }
  }

  return (
    <Dropdown className="audit-dropdown lisitng_dropdown">
      <Dropdown.Toggle as={CustomToggle}>
        <span className="audit-icon--action" />
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight className="audit-dropdown__menu">
        {!paneState.isExpandOpen && (
          <Dropdown.Item className="audit-dropdown__item" onClick={() => openExpand(data)}>
            <i
              className="audit-icon--black audit-icon--14 audit-icon--expand audit-icon--admin-menu"
              aria-hidden="true"
            ></i>
            {t('audit.menu.expand')}
          </Dropdown.Item>
        )}

        {expand && (
          <Dropdown.Item className="audit-dropdown__item" onClick={() => openExpandAudit(data)}>
            <i
              className="audit-icon--black audit-icon--14 audit-icon--expand audit-icon--admin-menu"
              aria-hidden="true"
            ></i>
            {t('audit.menu.expand')}
          </Dropdown.Item>
        )}

        {data.status !== 'completed' && auditPermission && (
          <Dropdown.Item className="audit-dropdown__item" onClick={() => openEditAudit(data)}>
            <i className="audit-icon--black audit-icon--14 audit-icon--pencil audit-icon--admin-menu"></i>
            {t('audit.menu.edit')}
          </Dropdown.Item>
        )}

        {auditPermission && (
          <Dropdown.Item className="audit-dropdown__item" onClick={() => openDuplicateAudit(data)}>
            <i className="audit-icon--black audit-icon--14 audit-icon--duplicate audit-icon--admin-menu"></i>
            {t('audit.menu.duplicate')}
          </Dropdown.Item>
        )}

        {getReopenAuditPermission() && (
          <Dropdown.Item
            className="audit-dropdown__item"
            onClick={() => {
              if (simpleModal) {
                simpleModal.show({
                  scheme: 'warning',
                  title: `${t('audit.alert.reopen-audit-title')} ${data.name}`,
                  description: t('audit.alert.reopen-audit-description'),
                  buttons: {
                    affirmative: {
                      label: t('audit.alert.confirm'),
                      click: (d, modal) => {
                        reopenAudit(data.id, () => modal.hide())
                      },
                    },
                    negative: {
                      label: t('audit.alert.cancel'),
                    },
                  },
                })
              }
            }}
          >
            <i className="audit-icon--black audit-icon--18 audit-icon--reopen audit-icon--admin-menu-9"></i>
            {t('audit.menu.reopen')}
          </Dropdown.Item>
        )}

        {isTemplate && (
          <Dropdown.Item className="audit-dropdown__item" onClick={() => openScheduleAudit(data)}>
            <i className="fa fa-calendar audit-icon--admin-menu"></i>
            {t('audit.menu.run_audit')}
          </Dropdown.Item>
        )}

        {getCloseAuditPermission() && (
          <Dropdown.Item
            className="audit-dropdown__item"
            onClick={() => {
              if (simpleModal) {
                simpleModal.show({
                  scheme: 'warning',
                  title: `${t('audit.alert.close-audit-title')} "${data.name}"`,
                  description: t('audit.alert.close-audit-description'),
                  buttons: {
                    affirmative: {
                      label: 'Close',
                      click: (d, modal) => {
                        closeAuditCall(data, () => modal.hide())
                      },
                    },
                    negative: {
                      label: 'Nevermind',
                    },
                  },
                })
              }
            }}
          >
            <i
              className="audit-icon--black audit-icon--14 audit-icon--circle-close audit-icon--admin-menu"
              aria-hidden="true"
            ></i>
            {t('audit.menu.close_audit')}
          </Dropdown.Item>
        )}

        {auditPermission && (
          <Dropdown.Item
            className="audit-dropdown__item audit-dropdown__item--red"
            onClick={() => {
              if (simpleModal) {
                let title = isTemplate ? t('audit.alert.template-title') : t('audit.alert.title')

                let description = t('audit.alert.template-description')
                if (!isTemplate) {
                  description = data.template_id
                    ? t('audit.alert.description')
                    : t('audit.alert.desciption-no-template')
                }

                let fnDelete = isTemplate ? deleteTemplate : deleteAudit

                simpleModal.show({
                  scheme: 'destructive',
                  title: `${title} "${data.name}"`,
                  description: description,
                  buttons: {
                    affirmative: {
                      label: t('audit.alert.delete'),
                      click: (d, modal) => {
                        fnDelete(data.id, () => modal.hide())
                      },
                    },
                    negative: {
                      label: t('audit.alert.cancel'),
                    },
                  },
                })
              }
            }}
          >
            <i
              className="audit-icon--red audit-icon--14 audit-icon--trash audit-icon--admin-menu"
              aria-hidden="true"
            ></i>
            {t('audit.menu.delete')}
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}
export default AuditAdminMenu
